import { jsPDF } from "jspdf";
import { LOGO_SAO_JORGE } from "./logoSaoJorge";

const MESES = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
const DIAS_SEM = ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"];
const azul = [23, 54, 120];
const preto = [20, 20, 20];
const cinza = [110, 110, 110];

const idadeDe = (iso) => {
  if (!iso) return "";
  const n = new Date(iso); if (isNaN(n)) return "";
  const h = new Date(); let a = h.getFullYear() - n.getFullYear();
  const m = h.getMonth() - n.getMonth();
  if (m < 0 || (m === 0 && h.getDate() < n.getDate())) a--;
  return `${a} anos`;
};
const fmtData = (iso) => {
  if (!iso) return "";
  const [d] = String(iso).split("T"); const [y, m, dd] = d.split("-");
  return dd ? `${dd}/${m}/${y}` : d;
};

const parseHorarios = (h) => {
  if (!h) return [];
  if (/necess|s\/n|sos/i.test(h)) return ["S/N"];
  const nums = String(h).match(/\d{1,2}:\d{2}|\d{1,2}/g) || [];
  return nums.map((n) => (n.includes(":") ? n.padStart(5, "0") : n.padStart(2, "0") + ":00"));
};

export function gerarPrescricaoMensal({ empresa, residente, medicacoes = [], profissional = {}, ano, mes }) {
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const SW = 297, SH = 210, M = 6;
  const nDias = new Date(ano, mes, 0).getDate(); // mes 1-12
  const leftW = 92, qtW = 10;
  const medX = M + qtW, medW = leftW - qtW;
  const gridX0 = M + leftW, gridW = SW - M - gridX0, cellW = gridW / nDias;

  // ---- monta grupos por horário ----
  const grupos = {}; // time -> [{qt, desc}]
  (medicacoes || []).forEach((r) => {
    const d = r.dados || {};
    const desc = [
      [d.medicamento, d.dose && `${d.dose}${d.unidade ? " " + d.unidade : ""}`].filter(Boolean).join(" "),
      d.via ? `Via ${String(d.via).toLowerCase()}` : "",
      d.horarios ? `Horários: ${d.horarios}` : "",
      d.observacao || "",
    ].filter(Boolean).join(" - ");
    const qt = d.dose || "1";
    const horas = parseHorarios(d.horarios);
    (horas.length ? horas : ["S/H"]).forEach((t) => {
      (grupos[t] = grupos[t] || []).push({ qt, desc });
    });
  });
  const horarios = Object.keys(grupos).sort((a, b) => {
    if (a === "S/N") return 1; if (b === "S/N") return -1;
    if (a === "S/H") return 1; if (b === "S/H") return -1;
    return a.localeCompare(b);
  });

  // linhas a desenhar: sequência de {tipo:'grupo'|'med', ...}
  const linhas = [];
  horarios.forEach((t) => {
    linhas.push({ tipo: "grupo", label: t === "S/H" ? "SEM HORÁRIO" : t === "S/N" ? "SE NECESSÁRIO (S/N)" : t });
    grupos[t].forEach((m) => {
      doc.setFontSize(7);
      const l = doc.splitTextToSize(m.desc, medW - 3);
      linhas.push({ tipo: "med", qt: m.qt, l, h: Math.max(9, l.length * 3.1 + 3.5) });
    });
  });
  if (!linhas.length) linhas.push({ tipo: "grupo", label: "Sem medicações cadastradas" });

  const desenharCabecalho = () => {
    // logo
    try {
      const img = empresa?.logo || LOGO_SAO_JORGE;
      const p = doc.getImageProperties(img); const ratio = p.width / p.height || 1;
      let lw = 40, lh = lw / ratio; if (lh > 26) { lh = 26; lw = lh * ratio; }
      doc.addImage(img, p.fileType || "PNG", M, 4, lw, lh);
    } catch (e) { /* ignore */ }
    // título central
    doc.setFont("helvetica", "bold"); doc.setFontSize(15); doc.setTextColor(...preto);
    doc.text(`Prescrição de ${MESES[mes - 1]} ${ano}`, SW / 2, 10, { align: "center" });
    // profissional (direita)
    doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(...cinza);
    doc.text("Profissional Responsável", SW - M, 8, { align: "right" });
    doc.setFont("helvetica", "bold"); doc.setFontSize(11); doc.setTextColor(...preto);
    doc.text(profissional?.nome || "-", SW - M, 14, { align: "right" });
    doc.setFontSize(9);
    doc.text(`Registro: ${profissional?.registro || "-"}`, SW - M, 19, { align: "right" });
    // bloco paciente
    let y = 18; const cx = 55;
    const linha = (lbl, val, x, yy, lblW = 14) => {
      doc.setFont("helvetica", "bold"); doc.setFontSize(9); doc.setTextColor(...preto);
      doc.text(lbl, x, yy);
      doc.setFont("helvetica", "normal"); doc.text(String(val || ""), x + lblW, yy);
    };
    linha("Nome:", residente?.nome, cx, y, 12); y += 5;
    linha("Idade:", idadeDe(residente?.dataNascimento), cx, y, 12);
    linha("Dt.", fmtData(residente?.dataNascimento), cx + 60, y, 8);
    linha("Leito:", residente?.quarto, cx + 130, y, 11); y += 5;
    linha("Convênio", residente?.convenio, cx, y, 18);
    linha("Dieta", residente?.dieta || "", cx + 130, y, 11); y += 5;
    linha("Alergias:", (residente?.alergias || ""), cx, y, 16);
    linha("Diagnóstico:", (residente?.diagnosticos || ""), cx + 130, y, 21);
    return 36;
  };

  const desenharGridHeader = (y) => {
    const hh = 8;
    doc.setDrawColor(140, 140, 140); doc.setLineWidth(0.3);
    // rótulo "Dia"
    doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor(...preto);
    doc.rect(M, y, leftW, hh);
    doc.text("Dia", M + 2, y + 5);
    // colunas de dias + dia da semana
    for (let d = 1; d <= nDias; d++) {
      const x = gridX0 + (d - 1) * cellW;
      doc.rect(x, y, cellW, hh);
      const wd = new Date(ano, mes - 1, d).getDay();
      doc.setFont("helvetica", "bold"); doc.setFontSize(cellW < 5 ? 5.5 : 6.5);
      doc.text(String(d), x + cellW / 2, y + 3.4, { align: "center" });
      doc.setFont("helvetica", "normal"); doc.setFontSize(4.5); doc.setTextColor(...cinza);
      doc.text(DIAS_SEM[wd], x + cellW / 2, y + 6.6, { align: "center" });
      doc.setTextColor(...preto);
    }
    return y + hh;
  };

  const desenharSubHeader = (y) => {
    const hh = 5.5;
    doc.setFillColor(230, 230, 230); doc.rect(M, y, leftW, hh, "F");
    doc.setDrawColor(140, 140, 140); doc.setLineWidth(0.3); doc.rect(M, y, leftW, hh);
    doc.setFont("helvetica", "bold"); doc.setFontSize(7.5); doc.setTextColor(...preto);
    doc.text("QT", M + 2, y + 3.8);
    doc.text("MEDICAMENTO", medX + 3, y + 3.8);
    return y + hh;
  };

  const desenharRodapeLegenda = () => {
    const y0 = SH - 17;
    doc.setDrawColor(140, 140, 140); doc.setLineWidth(0.3); doc.line(M, y0, SW - M, y0);
    // Legenda de checagem
    doc.setFont("helvetica", "bold"); doc.setFontSize(8); doc.setTextColor(...preto);
    doc.text("Legenda:", M, y0 + 6);
    let lx = M + 18;
    const item = (drawSym, label) => {
      drawSym(lx);
      doc.setFont("helvetica", "normal"); doc.setFontSize(7.5); doc.setTextColor(...preto);
      doc.text(label, lx + 5, y0 + 6);
      lx += 5 + doc.getTextWidth(label) + 8;
    };
    item((x) => { doc.setDrawColor(...preto); doc.setLineWidth(0.6); doc.line(x, y0 + 5, x + 1.4, y0 + 6.6); doc.line(x + 1.4, y0 + 6.6, x + 3.6, y0 + 3); }, "Administrado");
    item((x) => { doc.setFont("helvetica", "bold"); doc.setFontSize(9.5); doc.text("Ø", x, y0 + 6.2); }, "Não administrado");
    item((x) => { doc.setFont("helvetica", "bold"); doc.setFontSize(9.5); doc.text("F", x, y0 + 6.2); }, "Falta");
    item((x) => { doc.setFont("helvetica", "bold"); doc.setFontSize(9.5); doc.text("R", x, y0 + 6.2); }, "Recusa");
    // Carimbo e rubrica de quem administrou (por turno)
    const bw = 42, bh = 8, gap = 3, turnos = ["Manhã", "Tarde", "Noite"];
    const totalW = turnos.length * bw + (turnos.length - 1) * gap;
    const bx0 = SW - M - totalW;
    doc.setFont("helvetica", "bold"); doc.setFontSize(7); doc.setTextColor(...preto);
    doc.text("Carimbo e rubrica de quem administrou:", bx0, y0 + 3);
    turnos.forEach((t, i) => {
      const x = bx0 + i * (bw + gap);
      doc.setDrawColor(140, 140, 140); doc.setLineWidth(0.3); doc.rect(x, y0 + 4.5, bw, bh);
      doc.setFont("helvetica", "normal"); doc.setFontSize(6); doc.setTextColor(...cinza);
      doc.text(t, x + 1, y0 + 4.5 + bh - 0.8);
      doc.setTextColor(...preto);
    });
  };

  let pagY = desenharCabecalho();
  pagY = desenharGridHeader(pagY);
  pagY = desenharSubHeader(pagY);
  const LIM = SH - 21;

  const novaPagina = () => {
    desenharRodapeLegenda();
    doc.addPage();
    let y = desenharCabecalho();
    y = desenharGridHeader(y);
    y = desenharSubHeader(y);
    return y;
  };

  linhas.forEach((ln) => {
    if (ln.tipo === "grupo") {
      const hh = 5.5;
      if (pagY + hh > LIM) pagY = novaPagina();
      doc.setFillColor(224, 224, 224);
      doc.rect(M, pagY, leftW, hh, "F");
      doc.setDrawColor(140, 140, 140); doc.setLineWidth(0.3);
      doc.rect(M, pagY, leftW, hh);
      // grade dos dias (faixa do horário)
      doc.setFillColor(245, 245, 245);
      doc.rect(gridX0, pagY, gridW, hh, "F"); doc.rect(gridX0, pagY, gridW, hh);
      doc.setFont("helvetica", "bold"); doc.setFontSize(8); doc.setTextColor(...preto);
      doc.text(ln.label, gridX0 + gridW / 2, pagY + 3.8, { align: "center" });
      pagY += hh;
    } else {
      if (pagY + ln.h > LIM) pagY = novaPagina();
      doc.setDrawColor(140, 140, 140); doc.setLineWidth(0.3);
      // QT
      doc.rect(M, pagY, qtW, ln.h);
      doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor(...preto);
      doc.text(String(ln.qt), M + qtW / 2, pagY + 5, { align: "center" });
      // MEDICAMENTO
      doc.rect(medX, pagY, medW, ln.h);
      doc.setFontSize(7);
      doc.text(ln.l, medX + 2, pagY + 4);
      // quadradinhos por dia
      for (let d = 0; d < nDias; d++) {
        const x = gridX0 + d * cellW;
        doc.rect(x, pagY, cellW, ln.h);
      }
      pagY += ln.h;
    }
  });

  desenharRodapeLegenda();
  doc.save(`prescricao-${MESES[mes - 1]}-${ano}-${(residente?.nome || "paciente").replace(/\s+/g, "_")}.pdf`);
}
